import { NgModule } from '@angular/core';
import { DefaultComponentModule } from '@innogy/core/modules/components';
import { KnowledgeBaseSharedModule } from '@innogy/knowledge-base/shared';
import { PaginationByUrlComponent } from '@innogy/pagination';
import { DeployUrlPipe } from '@innogy/utils/environment';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LoadingComponent } from '@legacy/common-ui-shared';

import { MasonryCardComponent } from './masonry/masonry-card/masonry-card.component';
import { MasonryContainerComponent } from './masonry/masonry-container/masonry-container.component';
import { MasonryComponent } from './masonry/masonry.component';
import { OverviewComponent } from './overview/overview.component';

const exportedComponents = [
  MasonryComponent,
  MasonryContainerComponent,
  MasonryCardComponent,
  OverviewComponent,
];

@NgModule({
  imports: [
    DefaultComponentModule,
    KnowledgeBaseSharedModule,
    PaginationByUrlComponent,
    DeployUrlPipe,
    LazyLoadImageModule,
    LoadingComponent,
    ...exportedComponents,
  ],
  exports: [...exportedComponents],
})
export class KnowledgeBaseOverviewModule {}
